(() => {
  'use strict';
  const root=document.querySelector('[data-dg-lab-tool="backlight"]');
  if(!root) return;
  if(root.dataset['dgLabBacklightInitialized'] === 'true') return;
  root.dataset['dgLabBacklightInitialized'] = 'true';
  const stage=root.querySelector('#stage');
  const level=root.querySelector('#level');
  if(stage) stage.style.background='radial-gradient(circle at 50% 50%,#090909,#000 70%)';

  function setStatus(text){ const status=root.querySelector('.status'); if(status) status.textContent=text; }
  async function toggleFullscreen(target){
    if(!target || !document.fullscreenEnabled){ setStatus('No disponible'); return; }
    try{
      if(document.fullscreenElement) await document.exitFullscreen();
      else await target.requestFullscreen();
    }catch(error){ setStatus('No disponible'); }
  }

  root.querySelector('#full').addEventListener('click',()=>toggleFullscreen(stage));
  root.querySelector('#brightness').addEventListener('input',event=>{ if(stage) stage.style.filter=`brightness(${event.target.value}%)`; if(level) level.textContent=event.target.value; });
  document.addEventListener('fullscreenchange',()=>{ const state=root.querySelector('#state'); if(state) state.textContent=document.fullscreenElement?'Pantalla completa activa · Pulsa Esc para salir':'Listo'; });
})();
